import { createStore as reduxCreateStore } from 'redux'
import rootReducer from './reducers/root'

const createStore = () => reduxCreateStore(rootReducer)
export default createStore
